import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, Input } from '@angular/core';
import { ProfileAvatarModule } from '@app/profile';
import { HeaderMenuModule } from '@app/shell/header/menu/menu.module';
import { IconComponent } from '@app/tw-shared/components';
import { MenuButtonDirective, NavItemDirective } from '@app/tw-shared/directives';
import { DropdownOpenCloseService } from '@app/tw-shared/directives/dropdown-open-close/dropdown-open-close.service';
import { TranslateModule } from '@ngx-translate/core';
import { BehaviorSubject } from 'rxjs';
import { NavItemHelpService } from '../../services';
import { NavItemHelpListComponent } from '../nav-item-help-list/nav-item-help-list.component';
import { DataTestModule } from '@app/shared/directive/data-test';

@Component({
    selector: 'app-nav-item-help',
    imports: [
        CommonModule,
        IconComponent,
        TranslateModule,
        MenuButtonDirective,
        ProfileAvatarModule,
        HeaderMenuModule,
        NavItemHelpListComponent,
        DataTestModule,
        NavItemDirective,
    ],
    templateUrl: './nav-item-help.component.html',
    styleUrl: './nav-item-help.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [
        NavItemHelpService,
        {
            provide: DropdownOpenCloseService,
            useFactory: () => new DropdownOpenCloseService('dropdown'),
        },
    ]
})
export class NavItemHelpComponent {
    @Input({ required: true }) position: number;
    readonly hover$ = new BehaviorSubject<boolean>(false);

    private readonly navItemHelpService = inject(NavItemHelpService);
    private readonly dropdownOpenCloseService = inject(DropdownOpenCloseService);

    readonly open$ = this.dropdownOpenCloseService.openEvent$;
    readonly active$ = this.navItemHelpService.active$;
    readonly listId = this.navItemHelpService.listId;
}
